export default __webpack_public_path__ + "static/media/s14.55705c2c.png";